const SharingLevelsMapping = Object.freeze({
  0: 'My Organization',
  1: 'My Organization',
  2: 'Shared'
});
export default SharingLevelsMapping;